/**
 * legacyCallLogV2Url maps a v1 call-log URL to the canonical v2 path, so old
 * deep links forward to the right per-bot call log when v2 is active.
 *
 * v1 (all-bots view) emitted: `/call-logs/{callId}?bot={botId}` and
 * `/call-logs?bot={botId}`. v2 is per-bot and reads the bot from the path:
 * `/b/{botId}/call-logs/{callId}` (and `/b/{botId}/call-logs`).
 *
 * Returns the canonical v2 path when a rewrite is needed, or null when the URL
 * is already v2-canonical (`/b/...`) or can't be mapped (no `bot` param).
 */
export function legacyCallLogV2Url(pathname: string, search: string): string | null {
  if (pathname.startsWith('/b/')) return null; // already a per-bot (v2) path
  const m = pathname.match(/^\/call-logs(?:\/([^/]+))?\/?$/);
  if (!m) return null;
  const params = new URLSearchParams(search);
  const bot = params.get('bot');
  if (!bot) return null; // no bot id → nothing to forward to in per-bot v2
  const callSeg = m[1] ? `/${m[1]}` : '';
  // Drop the now-redundant ?bot; preserve any other query params.
  params.delete('bot');
  const rest = params.toString();
  return `/b/${encodeURIComponent(bot)}/call-logs${callSeg}${rest ? `?${rest}` : ''}`;
}
